/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import type { TdColorPickerProps } from './type';

export const colorPickerDefaultProps: TdColorPickerProps = {
  borderless: false,
  clearable: false,
  colorModes: ['monochrome', 'linear-gradient'],
  disabled: undefined,
  enableAlpha: false,
  enableMultipleGradient: true,
  format: 'RGB',
  defaultRecentColors: [],
  showPrimaryColorPreview: true,
  swatchColors: undefined,
};
